<!-- LIST -->
<div class="list-holder" *ngIf="view === 'list'">
    <div class="tools">
        <div class="search">
            <img src="../../../../../assets/okito/images/icons/magnifying.svg">
            <input type="text" class="text-search" placeholder="Search roles" [(ngModel)]="searchKeyword">
        </div>
        <div class="actions">
            <button class="btn btn-sm btn-outline" (click)="openActivity()">Activity</button>
            &nbsp;
            <button class="btn btn-sm btn-default" *ngIf="canManage" (click)="openCreate()">
                <i class="fa fa-plus"></i> Add Role
            </button>
        </div>
    </div>
    <p class="ar-hint">
        Superadmins hold every permission and need no role. Everyone else gets the permissions of every
        role assigned to them — assign roles from an admin's details on the Users tab.
    </p>
    <div class="list">
        <table>
            <thead>
                <tr>
                    <th>Role</th>
                    <th>Description</th>
                    <th>Permissions</th>
                    <th>Admins</th>
                    <th>Type</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="filteredRoles.length !== 0; else noRoles">
                    <tr *ngFor="let role of filteredRoles">
                        <td><strong>{{ role.name }}</strong></td>
                        <td class="ar-muted">{{ role.description || '—' }}</td>
                        <td>{{ role.permissions.length }} of {{ totalPermissions }}</td>
                        <td>{{ role.adminCount }}</td>
                        <td>
                            <span class="stat" [ngClass]="role.isSystem ? 'ar-system' : 'ar-custom'">
                                {{ role.isSystem ? 'System' : 'Custom' }}
                            </span>
                        </td>
                        <td><a (click)="openRole(role)" style="cursor: pointer;">View</a></td>
                    </tr>
                </ng-container>
                <ng-template #noRoles>
                    <tr>
                        <td colspan="6" class="no-records-msg">
                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                Roles are not available on this environment yet.
                            </h6>
                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'forbidden'">
                                You don't have permission to view roles.
                            </h6>
                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                Connection not available. Please try again.
                            </h6>
                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                No roles found
                            </h6>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
</div>

<!-- ROLE: view / edit / create -->
<div *ngIf="view === 'role'">
    <div class="ar-toolbar">
        <a class="ar-back" (click)="backToList()"><i class="fa fa-angle-left"></i> All roles</a>
        <div class="ar-actions">
            <ng-container *ngIf="!isEditing && canManage">
                <button class="btn btn-sm btn-outline" *ngIf="selected && !selected.isSystem"
                    [disabled]="!!deleteBlocker(selected)" [title]="deleteBlocker(selected) || ''"
                    (click)="confirmDelete(deleteModal)">Delete</button>
                &nbsp;
                <button class="btn btn-sm btn-default" (click)="startEdit()">Edit Role</button>
            </ng-container>
            <ng-container *ngIf="isEditing">
                <button class="btn btn-sm btn-outline" (click)="cancelEdit()">Cancel</button>
                &nbsp;
                <button class="btn btn-sm btn-default" [disabled]="isSaving" (click)="confirmSave(saveModal)">
                    {{ selected ? 'Save' : 'Create Role' }}
                </button>
            </ng-container>
        </div>
    </div>

    <div class="panel">
        <h3>
            {{ selected ? selected.name : 'New role' }}
            <span class="stat ar-system" *ngIf="selected?.isSystem">System</span>
        </h3>
        <div class="panel-info">
            <div class="panel-grp">
                <div class="mb-2 row">
                    <label class="col-sm-2 col-form-label">Name</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" [maxlength]="nameMax" placeholder="e.g. Finance"
                            [(ngModel)]="form.name" [disabled]="!isEditing || !!selected?.isSystem">
                        <small class="ar-hint" *ngIf="isEditing && selected?.isSystem">
                            A system role keeps its name; its permissions can still be changed.
                        </small>
                    </div>
                </div>
            </div>
            <div class="panel-grp">
                <div class="mb-2 row">
                    <label class="col-sm-2 col-form-label">Description</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" [maxlength]="descriptionMax"
                            placeholder="What this role is for" [(ngModel)]="form.description" [disabled]="!isEditing">
                    </div>
                </div>
            </div>
            <div class="panel-grp" *ngIf="selected">
                <div class="mb-2 row">
                    <label class="col-sm-2 col-form-label">Assigned to</label>
                    <div class="col-sm-10 col-form-label">
                        {{ selected.adminCount }} admin{{ selected.adminCount === 1 ? '' : 's' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="panel">
        <h3>Permissions <span class="ar-count">{{ form.permissions.size }} of {{ totalPermissions }}</span></h3>
        <p class="ar-hint">
            <strong>View</strong> opens a section; <strong>Manage</strong> changes it and includes View.
            <ng-container *ngIf="isEditing && !permissionsIsSuperadmin">
                Locked switches are permissions you don't hold — only someone who holds them can grant or remove them.
            </ng-container>
        </p>
        <div class="list-holder ar-grid-holder"><div class="list">
            <table class="ar-grid">
                <thead>
                    <tr>
                        <th>Section</th>
                        <th class="ar-col">View</th>
                        <th class="ar-col">Manage</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let section of sections">
                        <tr class="ar-section">
                            <td colspan="3">{{ section.section }}</td>
                        </tr>
                        <tr *ngFor="let module of section.modules">
                            <td>
                                <div class="ar-module">{{ module.label }}</div>
                                <div class="ar-muted">{{ module.description }}</div>
                            </td>
                            <td class="ar-col">
                                <div class="form-check form-switch" *ngIf="module.view; else noAction"
                                    [title]="lockReason(module.view)">
                                    <input class="form-check-input" type="checkbox" [checked]="has(module.view)"
                                        [disabled]="!canToggle(module.view)"
                                        (change)="toggle(module, 'view', $any($event.target).checked)">
                                </div>
                            </td>
                            <td class="ar-col">
                                <div class="form-check form-switch" *ngIf="module.manage; else noAction"
                                    [title]="lockReason(module.manage)">
                                    <input class="form-check-input" type="checkbox" [checked]="has(module.manage)"
                                        [disabled]="!canToggle(module.manage)"
                                        (change)="toggle(module, 'manage', $any($event.target).checked)">
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div></div>
    </div>
</div>

<ng-template #noAction><span class="ar-muted" title="This section has no such action">—</span></ng-template>

<!-- ACTIVITY -->
<div class="list-holder" *ngIf="view === 'activity'">
    <div class="ar-toolbar">
        <a class="ar-back" (click)="backToList()"><i class="fa fa-angle-left"></i> All roles</a>
    </div>
    <p class="ar-hint">Every change to a role or to an admin's roles, newest first.</p>
    <div class="list">
        <table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>By</th>
                    <th>Action</th>
                    <th>Target</th>
                    <th>Change</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="auditRows.length !== 0; else noAudit">
                    <tr *ngFor="let row of auditRows">
                        <td class="ar-nowrap">{{ row.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm A' }}</td>
                        <td>{{ row.actorName || row.actorAdminId }}</td>
                        <td>{{ actionLabel(row.action) }}</td>
                        <td>{{ row.targetLabel }}</td>
                        <td class="ar-muted">{{ row.summary }}</td>
                    </tr>
                </ng-container>
                <ng-template #noAudit>
                    <tr>
                        <td colspan="5" class="no-records-msg">
                            <h6 class="ponds-contents-med-bold">{{ auditLoading ? 'Loading…' : 'No activity yet' }}</h6>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
    <div class="list-footer">
        <div class="pager">
            <button (click)="fetchAudit(auditPage - 1)" [disabled]="auditLoading || auditPage <= 1">
                <img src="../../../../../assets/okito/images/icons/prev.svg"></button>
            <span class="ar-page">Page {{ auditPage }} of {{ auditPages }}</span>
            <button (click)="fetchAudit(auditPage + 1)" [disabled]="auditLoading || auditPage >= auditPages">
                <img src="../../../../../assets/okito/images/icons/next.svg"></button>
        </div>
    </div>
</div>

<!-- MODALS -->
<ng-template #saveModal let-modal class="modal">
    <div class="modal-header">
        <h4>{{ selected ? 'Save changes to ' + selected.name + '?' : 'Create ' + form.name.trim() + '?' }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="selected; else creatingSummary">
            <p *ngIf="selected.adminCount > 0">
                This takes effect immediately for the {{ selected.adminCount }}
                admin{{ selected.adminCount === 1 ? '' : 's' }} holding this role — no re-login needed.
            </p>
            <div *ngIf="pendingChanges.added.length">
                <strong>Granted</strong>
                <ul><li *ngFor="let label of pendingChanges.added">{{ label }}</li></ul>
            </div>
            <div *ngIf="pendingChanges.removed.length">
                <strong>Removed</strong>
                <ul><li *ngFor="let label of pendingChanges.removed">{{ label }}</li></ul>
            </div>
            <p *ngIf="!pendingChanges.added.length && !pendingChanges.removed.length" class="ar-muted">
                No permission changes.
            </p>
        </ng-container>
        <ng-template #creatingSummary>
            <p>The new role grants {{ form.permissions.size }} permission{{ form.permissions.size === 1 ? '' : 's' }}.
                Nobody holds it until you assign it to an admin.</p>
        </ng-template>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving" (click)="saveRole()">
            {{ selected ? 'Yes, Save' : 'Yes, Create' }}
        </button>
    </div>
</ng-template>

<ng-template #deleteModal let-modal class="modal">
    <div class="modal-header">
        <h4>Delete {{ selected?.name }}?</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>No admin holds this role. Deleting it cannot be undone; the activity log keeps a record of it.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving" (click)="deleteRole()">Yes, Delete</button>
    </div>
</ng-template>
